import * as React from 'react';
import { useTheme } from 'styled-components';

const NavHomeIcon = ({ isSelected }: { isSelected: boolean }) => {
	const theme = useTheme();
	const fillColor = isSelected ? theme.primaryBackground : 'white';

	return (
		<svg height="22" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11 0C10.9003 0 10.801 0.0300264 10.7162 0.0909632L0.174748 7.90445C-0.0223323 8.05244 -0.0589625 8.32587 0.0968681 8.51739C0.252699 8.70455 0.54062 8.73934 0.742283 8.59135L1.37517 8.12208V19.5647C1.37517 19.8041 1.58141 20 1.83349 20H8.25005V12.1653H13.75V20H20.1665C20.4186 20 20.6248 19.8041 20.6248 19.5647V8.12208L21.2577 8.59135C21.3448 8.65228 21.4407 8.68316 21.5415 8.68316C21.679 8.68316 21.8115 8.6262 21.9031 8.51739C22.059 8.32587 22.0223 8.05244 21.8253 7.90445L11.2838 0.0909632C11.199 0.0300264 11.0997 0 11 0ZM15.5833 1.71895V2.17632L18.3332 4.21321V1.71895H15.5833Z"
				fill={fillColor}
			/>
		</svg>
	);
};

export default NavHomeIcon;
